import { ArrowTopRightIcon, BackpackIcon, CrossCircledIcon, MagnifyingGlassIcon, MixerHorizontalIcon, MixerVerticalIcon } from "@radix-ui/react-icons"
import { Box, Button, Container, Flex, Heading, RadioGroup, Table, Text, TextField } from "@radix-ui/themes"
import React, { useEffect, useMemo, useState } from "react"
import AppTable from "../../components/controls/tables/AppTable"
import { ScrollArea } from "@radix-ui/themes"
import Pagination from "../../components/common/renders/pagination-render"
import { Select } from "@radix-ui/themes"
import useFetch from "../../core/hooks/useFetch"
import TransactionService from '../../core/services/TransactionService'
import {ITransaction} from '../../core/types/services-types/transaction-types'
import moment from 'moment'
import {toast, ToastContainer} from 'react-toastify'
import { Link } from "react-router"
export default function Transactions() {
    const [showFilters, setShowFilters] = useState<boolean>(false)
    const [page, setPage] = useState<number>(0)
    const [limit, setLimit] = useState<number>(100)
    const [totalCount, setTotalCount] = useState<number>(0)
    const [transactions, setTransactions] = useState<ITransaction[]>([])
    const [search, setSearch] = useState<string>('')
    const [max, setMax] = useState<string | number>('')
    const [min, setMin] = useState<string | number>('')
    const [type, setType] = useState<string>('')
    const [currency, setCurrency] = useState<string>('')
    const [dateSort, setDateSort] = useState<'DESC' | 'ASC'>('DESC')
    const [transactionsHeadersTableFormat, setTransactionsHeadersTableFormat] = useState<any[]>([
        "ID",
        "Внешний ID",
        "Отправитель",
        "Тип",
        "Валюта",
        "Комиссия",
        "Количество",
        "Куда",
        "Статус",
        "Сообщение",
        "Тип отправителя",
        "Разделенный платеж",
        "ID Состава Субъекта права",
        "Создано",
        "Обновлено",
        "Действия"
    ])
    const changeActiveIndex = (index: number) => {
        setPage(index)
    }

    const renderOption = (key: string, value: any) => {
        if(key === 'status') {
            if(value === 'created') {
                return ( 
                <Table.Cell>
                   <Text color='orange'> Создана </Text>
                    </Table.Cell>
                )
            }
            if(value === 'success') {
                return (
                    <Table.Cell>
                   <Text color="grass"> Подтверждена </Text>
                    </Table.Cell>
                
                )
            }
        }
        if(key === 'splitted') {
            if(value === true) {
                return (
                   <Table.Cell>
                   <Text color="grass"> Да </Text>
                    </Table.Cell>
                )
            }
            else {
                return (
                    <Table.Cell>
                   <Text color="grass"> Нет </Text>
                    </Table.Cell>
                )
            }
        }
        if(key === 'createdAt' || key === 'updatedAt') {
           return ( 
            <Table.Cell>
           { moment(value).format("DD.MM.YYYY HH:mm")}
            </Table.Cell>
           )
        }
        if(key === 'message') {
            if(value) {
            return (
                 <Table.Cell>
           {value.substring(0, 40)}...
            </Table.Cell>
            )
        }
        }
        return <Table.Cell>{value}</Table.Cell>
    }



    const [fetchRemoveTransaction, isLoadingFetchRemoveTransaction, errorFetchRemoveTransaction, errorsFetchRemoveTransaction] = useFetch(async (id: number | string) => {
        const data = await TransactionService.Delete(id)
        setTransactions(prev => prev.filter(tr => tr.id !== id))
        toast.success(data.message)
    })


    const [fetchTransactionsFilters, isLoadingFetchTransactionsFilters, errorFetchTransactionsFilters, errorsFetchTransactionsFilters] = useFetch(async () => {
        const data = await TransactionService.GetAllFilters(search, min, max, type, currency, dateSort, limit, page)
        setTransactions(data.data)
        setTotalCount(data.count)
    })

    useEffect(() => {
        if(errorFetchTransactionsFilters) toast.error(errorFetchTransactionsFilters)
    }, [errorFetchTransactionsFilters])

  const transactionsTableFormat = useMemo(() => {
    return transactions.map(item => {
        const filterItem = {
            ...item,
            user_id: item.sender.login,
            sender: '',
            receiver: '',
            to: item.receiver?.login ?? ''
        }

        const actions = [
            "Действия",
            <Flex gap={'3'} key={item.id}>
                <Link to={`/transaction/${item.id}`}>
                    <Button variant='surface'>
                        <ArrowTopRightIcon />
                    </Button>
                </Link>
                <Button color="red" onClick={async () => await fetchRemoveTransaction(item.id)}><CrossCircledIcon /></Button>
            </Flex>
        ]

        return Object.entries(filterItem).concat([actions])
    })
}, [transactions])

   
    useEffect(() => {
        fetchTransactionsFilters()
    }, [page])
    return (
        <Box className="md:p-5 pt-5 bg-zinc-100 min-h-[100vh]">
            <ToastContainer />
            <Box className="bg-zinc-50 rounded-lg shadow-lg p-10">
            <Container className="heading-transactions"> 
           <Heading className="flex items-center justify-center gap-2 p-5">
               <BackpackIcon width={20} height={20} /> Транзакции
           </Heading>
           <Container className="filters">
                <Flex> 
                <TextField.Root className="container" placeholder="Поиск по ID, ID касссы" value={search} onChange={e => setSearch(e.target.value)}>
                    <TextField.Slot>
                        <MagnifyingGlassIcon />
                    </TextField.Slot>
                </TextField.Root>
                <Button onClick={() => setShowFilters(!showFilters)}>
                    <MixerHorizontalIcon />
                    Фильтры
                </Button>
                </Flex>
                {
                    showFilters &&
                    <Container className="block-filters p-5">
                    <Flex className="pb-3" gap={'3'} wrap={'wrap'}>
                        <Box> 
                        <Text>Мин цена</Text>
                        <TextField.Root placeholder="Цена, от" type="number" value={min} onChange={e => setMin(e.target.value)}>

                        </TextField.Root>
                        </Box>

                        <Box> 

                        <Text>Макс цена</Text>
                        <TextField.Root placeholder="Цена, до" type="number" value={max} onChange={e => setMax(e.target.value)}>

                        </TextField.Root>
                        </Box>
                        <Flex direction={'column'}>
                        <Text>Тип транзакции</Text>
                        <Select.Root defaultValue="Пополнение баланса" value={type} onValueChange={e => setType(e)}>
		<Select.Trigger variant='surface'/>
		<Select.Content>
            <Select.Item value="empty">Без выбора</Select.Item>
			<Select.Item value="Внутренний перевод валюты">Внутренний перевод валюты</Select.Item>
            <Select.Item value="Вывод средств">Вывод средств</Select.Item>
            <Select.Item value="Распределение средств в Минфин">Распределение средств в Минфин</Select.Item>
		</Select.Content>
	</Select.Root>
    </Flex>

    <Flex direction={'column'}>
         <Text>Валюта</Text>
        <Select.Root defaultValue="Рубль" value={currency} onValueChange={e => setCurrency(e)}>
		<Select.Trigger variant='surface' />
		<Select.Content>
            <Select.Item value="empty">Без выбора</Select.Item>
			<Select.Item value="Рубль">Рубль</Select.Item>
            <Select.Item value="Рассвет">Рассвет</Select.Item>
		</Select.Content>
	</Select.Root>
    </Flex>
                   <Flex direction={'column'}>
                        <Text>Сортировать по дате</Text>
                        <RadioGroup.Root defaultValue={dateSort} name="date_sort" onValueChange={e => setDateSort(e)}>
	                    <RadioGroup.Item value="DESC">По убыванию</RadioGroup.Item>
	                    <RadioGroup.Item value="ASC">По возрастанию</RadioGroup.Item>
                        </RadioGroup.Root>
                   </Flex>
                    </Flex>
                    <Button variant='classic' color='indigo' onClick={async () => fetchTransactionsFilters()} loading={isLoadingFetchTransactionsFilters} >
                        <MixerVerticalIcon />
                        Применить фильтры
                    </Button>
                </Container>
                }

           </Container>
           <hr />
           </Container>
           <ScrollArea type="always" scrollbars="both" style={{ height: 650 }} >
            {
            isLoadingFetchTransactionsFilters ? 
            "Загрузка..."
                :
                <AppTable
                headers={transactionsHeadersTableFormat} 
                data={transactionsTableFormat}
                renderOption={renderOption}
                />
            }
           
           </ScrollArea>
           <Container className="p-2"> 
           <Pagination 
           total={totalCount} 
           count={limit} 
           activeIndex={page}
           onChangeIndex={changeActiveIndex}
           />
           </Container>
        </Box>
        </Box>
    )
}